import { ArrowDown } from "lucide-react";
import { Reveal } from "./Reveal";

const CHAIN = [
  "Brand Strategy",
  "Visual Identity",
  "Social Content",
  "Reels & Video",
  "Website",
  "AI Marketing",
];

export const WhatWeBuild = () => (
  <section
    data-testid="what-we-build-section"
    className="relative py-28 lg:py-40 bg-black overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="absolute -right-40 top-1/4 w-[500px] h-[500px] bg-[#6D00FF]/8 blur-[180px] rounded-full pointer-events-none"
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-16 lg:gap-24">
      <div className="lg:sticky lg:top-32 self-start">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#8B2CFF] mb-6">
            What We Can Build
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight leading-[1.05]">
            From <span className="text-gradient-purple">one idea…</span>
          </h2>
          <p className="mt-7 text-base sm:text-lg text-[#A6A6B0] leading-relaxed max-w-md">
            Give us a single spark — we turn it into everything your brand needs to exist,
            speak and grow.
          </p>
        </Reveal>
      </div>

      <div>
        {CHAIN.map((c, i) => (
          <Reveal key={c} delay={i * 0.06} y={24}>
            <div data-testid={`build-step-${i}`}>
              <div className="group flex items-center gap-6 py-5 border-b border-white/[0.06]">
                <span className="font-display text-xs font-bold tracking-[0.2em] text-[#8B2CFF]/70 group-hover:text-[#C43CFF] transition-colors duration-500">
                  0{i + 1}
                </span>
                <span className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight group-hover:translate-x-1.5 transition-transform duration-500">
                  {c}
                </span>
              </div>
              {i < CHAIN.length - 1 && (
                <ArrowDown className="w-4 h-4 my-2.5 ml-1 text-[#8B2CFF]/60" aria-hidden="true" />
              )}
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.2}>
          <p
            data-testid="build-final"
            className="mt-12 font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tighter text-gradient-purple"
          >
            One complete brand.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
